<section class="items">
  <h2 class="items__title">
    <noda-translate key="main-v2.reviews.title" />
  </h2>
  <div class="items__container">
    <swiper
      class="reviews-v2-swiper"
      [config]="config"
    >
      @for (item of reviews; track item.id) {
      <ng-template swiperSlide>
        <noda-testimonial
          nodaVisibility
          theme="white"
          type="default"
          [avatarRoute]="item.img | map : getImagePath"
          [logoName]="item.logo"
          [logoRoute]="item.logo | map : getImagePath"
          [reviewText]="item.text"
          [reviewTitle]="item.title"
          [userCompany]="item.company"
          [userName]="item.name"
          [userPosition]="item.role"
        />
      </ng-template>
      }
    </swiper>
  </div>
  <div class="reviews-v2-pagination custom-pagination"></div>
</section>
